const D = /* @__PURE__ */ new Map(), N = new Array(256);
function $(e, n, s, c) {
  D.set(n, [e, s]), N[e + 128] = c;
}
class O {
  constructor(n, s) {
    this.type = n, this.data = s;
  }
}
const a = new Uint8Array(256);
{
  let e = 0;
  for (; e < 128; )
    a[e++] = 0;
  for (; e < 144; )
    a[e++] = 1;
  for (; e < 160; )
    a[e++] = 2;
  for (; e < 192; )
    a[e++] = 3;
  for (; e < 224; ++e)
    a[e] = e - 188;
  for (e = 224; e <= 255; ++e)
    a[e] = 36;
}
const C = new TextDecoder("utf-8", { fatal: !0 }), _ = Object.seal({
  nilValue: void 0,
  badUTF8Handler: (e) => e.slice(),
  unknownExtHandler: (e, n) => new O(e, n),
  forceES6Map: !1
});
let w, l, i;
function A() {
  return l.getUint8(i++);
}
function h() {
  const e = l.getUint16(i);
  return i += 2, e;
}
function b() {
  const e = l.getUint32(i);
  return i += 4, e;
}
function R() {
  const e = l.getUint32(i);
  if (e >= 1 << 21) {
    const s = l.getBigUint64(i);
    return i += 8, s;
  }
  i += 4;
  const n = e * 4294967296 + l.getUint32(i);
  return i += 4, n;
}
function F() {
  return l.getInt8(i++);
}
function L() {
  const e = l.getInt16(i);
  return i += 2, e;
}
function j() {
  const e = l.getInt32(i);
  return i += 4, e;
}
function G() {
  if (typeof BigInt == "function") {
    const e = l.getBigInt64(i);
    return i += 8, e <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(e) : e;
  }
  throw new TypeError("msgpack: encountered 64-bit signed integer but BigInts are not supported (fallback code is possible which decodes 4 bytes at a time and computes the final number but implementation is tricky--PRs welcome!)");
}
function H() {
  const e = l.getFloat32(i);
  return i += 4, e;
}
function q() {
  const e = l.getFloat64(i);
  return i += 8, e;
}
function B(e) {
  const n = i;
  return i += e, w.slice(n, i);
}
function m(e) {
  const n = i;
  i += e;
  const s = w.subarray(n, i);
  try {
    return C.decode(s);
  } catch {
    return _.badUTF8Handler(s);
  }
}
function x(e) {
  const n = [];
  for (let s = 0; s < e; ++s)
    n.push(y());
  return n;
}
function k(e, n = _.forceES6Map) {
  if (n) {
    const u = /* @__PURE__ */ new Map();
    for (let g = 0; g < e; ++g)
      u.set(y(), y());
    return u;
  }
  const s = i, c = {};
  for (let u = 0; u < e; ++u) {
    const g = y();
    if (typeof g == "object")
      return i = s, k(e, !0);
    c[g] = y();
  }
  return c;
}
function U(e) {
  const n = F(), s = B(e), c = N[n + 128];
  return c ? c(s) : _.unknownExtHandler(n, s);
}
function y() {
  const e = A();
  switch (a[e]) {
    case 0:
      return e;
    case 1:
      return k(e & 15);
    case 2:
      return x(e & 15);
    case 3:
      return m(e & 31);
    case 4:
      return _.nilValue;
    case 5:
      return;
    case 6:
      return !1;
    case 7:
      return !0;
    case 8:
      return B(A());
    case 9:
      return B(h());
    case 10:
      return B(b());
    case 11:
      return U(A());
    case 12:
      return U(h());
    case 13:
      return U(b());
    case 14:
      return H();
    case 15:
      return q();
    case 16:
      return A();
    case 17:
      return h();
    case 18:
      return b();
    case 19:
      return R();
    case 20:
      return F();
    case 21:
      return L();
    case 22:
      return j();
    case 23:
      return G();
    case 24:
      return U(1);
    case 25:
      return U(2);
    case 26:
      return U(4);
    case 27:
      return U(8);
    case 28:
      return U(16);
    case 29:
      return m(A());
    case 30:
      return m(h());
    case 31:
      return m(b());
    case 32:
      return x(h());
    case 33:
      return x(b());
    case 34:
      return k(h());
    case 35:
      return k(b());
    case 36:
      return e - 256;
  }
}
function ee(e) {
  const n = w, s = l, c = i;
  w = e instanceof Uint8Array ? e : new Uint8Array(e), l = new DataView(w.buffer, w.byteOffset), i = 0;
  const u = y();
  return w = n, l = s, i = c, u;
}
const K = new TextEncoder();
let f = new Uint8Array(128), r = new DataView(f.buffer), t = 0;
function E(e) {
  throw new RangeError("[msgpack-es] cannot encode: " + e);
}
function S(e) {
  f = new Uint8Array(e), r = new DataView(f.buffer);
}
function o(e) {
  const n = t + e;
  if (n > f.length) {
    const s = f;
    S(Math.max(s.length * 2, n)), f.set(s);
  }
}
function M() {
  o(1), r.setUint8(t++, 192);
}
function X(e) {
  o(1), r.setUint8(t++, e ? 195 : 194);
}
function V(e) {
  e >= 0 ? e < 128 ? (o(1), r.setUint8(t++, e)) : e < 256 ? (o(2), r.setUint8(t++, 204), r.setUint8(t++, e)) : e < 65536 ? (o(3), r.setUint8(t++, 205), r.setUint16(t, e), t += 2) : e < 4294967296 ? (o(5), r.setUint8(t++, 206), r.setUint32(t, e), t += 4) : (o(9), r.setUint8(t++, 207), r.setUint32(t, e / 4294967296), t += 4, r.setUint32(t, e), t += 4) : e >= -32 ? (o(1), r.setInt8(t++, e)) : e >= -256 ? (o(2), r.setUint8(t++, 208), r.setInt8(t++, e)) : e >= -65536 ? (o(3), r.setUint8(t++, 209), r.setInt16(t, e), t += 2) : e >= -4294967296 ? (o(5), r.setUint8(t++, 210), r.setInt32(t, e), t += 4) : (o(9), r.setUint8(t++, 203), r.setFloat64(t, e), t += 8);
}
function z(e) {
  Number.isSafeInteger(e) ? V(e) : (o(9), r.setUint8(t++, 203), r.setFloat64(t, e), t += 8);
}
function J(e) {
  e >= BigInt(Number.MIN_SAFE_INTEGER) && e <= BigInt(Number.MAX_SAFE_INTEGER) ? V(Number(e)) : e < 0 ? (e <= -(BigInt(2) ** BigInt(63)) && E(`BigInt (${e}) is <= -2^63`), o(9), r.setUint8(t++, 211), r.setBigInt64(t, e), t += 8) : e < BigInt(2) ** BigInt(64) ? (o(9), r.setUint8(t++, 207), r.setBigUint64(t, e), t += 8) : E(`BigInt (${e}) is >= 2^64`);
}
function d(e, n, s, c) {
  e.length < 256 ? (o(2 + e.length), r.setUint8(t++, n), r.setUint8(t++, e.length)) : e.length < 65536 ? (o(3 + e.length), r.setUint8(t++, s), r.setUint16(t, e.length), t += 2) : length < 4294967296 ? (o(5 + e.length), r.setUint8(t++, c), r.setUint32(t, e.length), t += 4) : E(`binary/string length (${e.length}) >= 2^32`), f.set(e, t), t += e.byteLength;
}
function W(e) {
  const n = K.encode(e);
  n.length < 32 ? (o(1 + n.byteLength), r.setUint8(t++, 160 | n.byteLength), f.set(n, t), t += n.byteLength) : d(n, 217, 218, 219);
}
function Q(e) {
  d(e instanceof ArrayBuffer ? new Uint8Array(e) : e, 196, 197, 198);
}
function Y(e) {
  e < 16 ? (o(1), r.setUint8(t++, 144 | e)) : e < 65536 ? (o(3), r.setUint8(t++, 220), r.setUint16(t, e), t += 2) : (o(5), r.setUint8(t++, 221), r.setUint32(t, e), t += 4);
}
function T(e) {
  e < 16 ? (o(1), r.setUint8(t++, 128 | e)) : e < 65536 ? (o(3), r.setUint8(t++, 222), r.setUint16(t, e), t += 2) : e < 4294967296 ? (o(5), r.setUint8(t++, 223), r.setUint32(t, e), t += 4) : E(`2^32 or more (${e}) entries in map`);
}
function Z(e, n) {
  n.length === 8 ? (o(10), f[t++] = 215, f[t++] = e, f.set(n, t), t += 8) : n.length < 65536 ? (o(4 + n.length), f[t++] = 200, r.setUint16(t, n.length), t += 2, f[t++] = e, f.set(n, t), t += n.length) : n.length < 4294967296 ? (o(6 + n.length), f[t++] = 201, r.setUint32(t, n.length), t += 4, f[t++] = e, f.set(n, t), t += n.length) : E(`ext length (${n.length}) >= 2^32`);
}
function p(e) {
  switch (typeof e) {
    case "undefined":
      M();
      break;
    case "boolean":
      X(e);
      break;
    case "number":
      z(e);
      break;
    case "bigint":
      J(e);
      break;
    case "string":
      W(e);
      break;
    case "object":
      if (e === null) {
        M();
        return;
      }
      const n = D.get(e.constructor);
      if (n)
        Z(n[0], n[1](e));
      else if (e instanceof Uint8Array || e instanceof ArrayBuffer)
        Q(e);
      else if (Array.isArray(e))
        Y(e.length), e.forEach(p);
      else if (e instanceof Map) {
        const s = Array.from(e.keys()).filter((c) => {
          const u = typeof c, g = typeof e.get(c);
          return u !== "function" && g !== "function" && g !== "undefined";
        });
        T(s.length), s.forEach((c) => {
          p(c), p(e.get(c));
        });
      } else {
        const s = Object.keys(e).filter((c) => {
          const u = typeof e[c];
          return u !== "undefined" && u !== "function";
        });
        T(s.length), s.forEach((c) => {
          p(c), p(e[c]);
        });
      }
      break;
  }
}
function v(e, n = 0) {
  return n > f.length && S(n), t = 0, p(e), f.subarray(0, t);
}
function te(e, n = 0) {
  const s = f, c = r, u = t, g = v(e, n).slice();
  return f = s, r = c, t = u, g;
}
const P = new Uint8Array(12), I = new DataView(P.buffer);
$(
  -1,
  Date,
  (e) => {
    const n = e.getTime(), s = Math.floor(n / 1e3), c = (n - s * 1e3) * 1e6;
    return n >= 0 && s < 2 ** 34 ? (I.setUint32(0, (c << 2) + Math.floor(s / 4294967296)), I.setUint32(4, s % 4294967296), P.subarray(0, 8)) : (I.setUint32(0, c), I.setInt32(4, Math.trunc(s / 4294967296)), I.setUint32(8, s % 4294967296), P);
  },
  (e) => {
    const n = new DataView(e.buffer, e.byteOffset, e.length);
    switch (e.length) {
      case 4:
        return new Date(n.getUint32(0) * 1e3);
      case 8: {
        const s = n.getUint32(0), c = s >>> 2, u = (s & 3) * 4294967296 + n.getUint32(4);
        return new Date(u * 1e3 + Math.floor(c / 1e6));
      }
      case 12: {
        const s = n.getUint32(0), u = (n.getInt32(4) * 4294967296 + n.getUint32(8)) * 1e3 + Math.floor(s / 1e6);
        if (!Number.isSafeInteger(u))
          throw new RangeError("msgpack: decodeDate (ext -1): timestamp exceeds safe JS integer range");
      }
      default:
        throw new RangeError(`msgpack: decodeDate (ext -1): invalid data length (${e.length})`);
    }
  }
);
export {
  _ as DECODE_OPTS,
  O as UnknownExt,
  ee as decode,
  te as encode,
  v as encodeView,
  $ as registerExtension,
  S as resizeEncodingBuffer
};
